import { DASHBOARD_MODULE, DASHBOARD_PRO_MODULE } from "../../constants";
import { useHasPermission } from "../../utils";
import { ProtectedRoute } from "../../utils/ProtectedRoute";
import { Dashboard } from "./Dashboard";
import { DashboardPro } from "./DashboardPro";

export function DashboardRoute() {
  const hasDashboardPro = useHasPermission(DASHBOARD_PRO_MODULE);

  return (
    <ProtectedRoute
      permissions={[DASHBOARD_MODULE, DASHBOARD_PRO_MODULE]}
      component={hasDashboardPro ? DashboardPro : Dashboard}
    />
  );
}
